import {action, makeAutoObservable} from "mobx"
import {RootStore} from "../index";
import ClientModel from "../../model/ClientModel";

export class PageClientsStore {
    private rootStore: RootStore | undefined;

    public error: string = '';
    public search: string = '';
    public arItems = [];

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    init() {
        ClientModel.getClientsFull(this.setClients, this.setError);
    }

    @action setClients = (result: any) => {
        this.arItems = [];
        result.data.map((item: any) => {
            item['show'] = false;
            item.overdueDebt = parseFloat(item.overdueDebt.split(',').join('').substr(1));
            item.totalDebt = parseFloat(item.totalDebt.split(',').join('').substr(1));
            return item;
        });
        this.arItems = result.data;
    }

    @action
    setError = (error: any) => {
        console.log(error);
        // this.error = error.response.data.message;
    }

    @action onFilterClient = (e: any) => {
        this.search = e.target.value;
    }

    @action onChangeShow = (item: any) => {
        item.show = !item.show;
    }
}


